// TODO: Load from the API instead of hardcoding here. This is just a temporary solution to get the app up and running quickly.
const countriesDictionary = {
  'AD': { label: 'Andorra', type: 'Country' },
  'AE': { label: 'United Arab Emirates', type: 'Country' },
  'AF': { label: 'Afghanistan', type: 'Country' },
  'AG': { label: 'Antigua and Barbuda', type: 'Country' },
  'AL': { label: 'Albania', type: 'Country' },
  'AN': { label: 'Netherlands Antilles', type: 'Former Country' },
  'AM': { label: 'Armenia', type: 'Country' },
  'AO': { label: 'Angola', type: 'Country' },
  'AR': { label: 'Argentina', type: 'Country' },
  'AT': { label: 'Austria', type: 'Country' },
  'AU': { label: 'Australia', type: 'Country' },
  'AZ': { label: 'Azerbaijan', type: 'Country' },
  'BA': { label: 'Bosnia and Herzegovina', type: 'Country' },
  'BB': { label: 'Barbados', type: 'Country' },
  'BD': { label: 'Bangladesh', type: 'Country' },
  'BE': { label: 'Belgium', type: 'Country' },
  'BF': { label: 'Burkina Faso', type: 'Country' },
  'BG': { label: 'Bulgaria', type: 'Country' },
  'BH': { label: 'Bahrain', type: 'Country' },
  'BI': { label: 'Burundi', type: 'Country' },
  'BJ': { label: 'Benin', type: 'Country' },
  'BN': { label: 'Brunei', type: 'Country' },
  'BO': { label: 'Bolivia', type: 'Country' },
  'BR': { label: 'Brazil', type: 'Country' },
  'BS': { label: 'Bahamas', type: 'Country' },
  'BT': { label: 'Bhutan', type: 'Country' },
  'BW': { label: 'Botswana', type: 'Country' },
  'BY': { label: 'Belarus', type: 'Country' },
  'BZ': { label: 'Belize', type: 'Country' },
  'CA': { label: 'Canada', type: 'Country' },
  'CD': { label: 'Democratic Republic of the Congo', type: 'Country' },
  'CF': { label: 'Central African Republic', type: 'Country' },
  'CG': { label: 'Republic of the Congo', type: 'Country' },
  'CH': { label: 'Switzerland', type: 'Country' },
  'CI': { label: 'Ivory Coast', type: 'Country' },
  'CK': { label: 'Cook Islands', type: 'Country' },
  'CL': { label: 'Chile', type: 'Country' },
  'CM': { label: 'Cameroon', type: 'Country' },
  'CN': { label: 'China', type: 'Country' },
  'CO': { label: 'Colombia', type: 'Country' },
  'CR': { label: 'Costa Rica', type: 'Country' },
  'CU': { label: 'Cuba', type: 'Country' },
  'CV': { label: 'Cape Verde', type: 'Country' },
  'CY': { label: 'Cyprus', type: 'Country' },
  'CZ': { label: 'Czech Republic', type: 'Country' },
  'DE': { label: 'Germany', type: 'Country' },
  'DJ': { label: 'Djibouti', type: 'Country' },
  'DK': { label: 'Denmark', type: 'Country' },
  'DM': { label: 'Dominica', type: 'Country' },
  'DO': { label: 'Dominican Republic', type: 'Country' },
  'DZ': { label: 'Algeria', type: 'Country' },
  'EC': { label: 'Ecuador', type: 'Country' },
  'EE': { label: 'Estonia', type: 'Country' },
  'EG': { label: 'Egypt', type: 'Country' },
  'ER': { label: 'Eritrea', type: 'Country' },
  'ES': { label: 'Spain', type: 'Country' },
  'ET': { label: 'Ethiopia', type: 'Country' },
  'FI': { label: 'Finland', type: 'Country' },
  'FJ': { label: 'Fiji', type: 'Country' },
  'FM': { label: 'Micronesia', type: 'Country' },
  'FR': { label: 'France', type: 'Country' },
  'GA': { label: 'Gabon', type: 'Country' },
  'GB': { label: 'United Kingdom', type: 'Country' },
  'GD': { label: 'Grenada', type: 'Country' },
  'GE': { label: 'Georgia', type: 'Country' },
  'GF': { label: 'French Guiana', type: 'Territory of France' },
  'GH': { label: 'Ghana', type: 'Country' },
  "GI": { label: 'Gibraltar', type: 'British Overseas Territory' },
  'GM': { label: 'Gambia', type: 'Country' },
  'GN': { label: 'Guinea', type: 'Country' },
  'GQ': { label: 'Equatorial Guinea', type: 'Country' },
  'GR': { label: 'Greece', type: 'Country' },
  'GT': { label: 'Guatemala', type: 'Country' },
  'GW': { label: 'Guinea-Bissau', type: 'Country' },
  'GY': { label: 'Guyana', type: 'Country' },
  'HN': { label: 'Honduras', type: 'Country' },
  'HR': { label: 'Croatia', type: 'Country' },
  'HT': { label: 'Haiti', type: 'Country' },
  'HU': { label: 'Hungary', type: 'Country' },
  'ID': { label: 'Indonesia', type: 'Country' },
  'IE': { label: 'Ireland', type: 'Country' },
  'IL': { label: 'Israel', type: 'Country' },
  'IN': { label: 'India', type: 'Country' },
  'IQ': { label: 'Iraq', type: 'Country' },
  'IR': { label: 'Iran', type: 'Country' },
  'IS': { label: 'Iceland', type: 'Country' },
  'IT': { label: 'Italy', type: 'Country' },
  'JM': { label: 'Jamaica', type: 'Country' },
  'JO': { label: 'Jordan', type: 'Country' },
  'JP': { label: 'Japan', type: 'Country' },
  'KE': { label: 'Kenya', type: 'Country' },
  'KG': { label: 'Kyrgyzstan', type: 'Country' },
  'KH': { label: 'Cambodia', type: 'Country' },
  'HK': { label: 'Hong Kong', type: 'Special Administrative Region of China' },
  'KI': { label: 'Kiribati', type: 'Country' },
  'KM': { label: 'Comoros', type: 'Country' },
  'KN': { label: 'Saint Kitts and Nevis', type: 'Country' },
  'KP': { label: 'North Korea', type: 'Country' },
  'KR': { label: 'South Korea', type: 'Country' },
  'KW': { label: 'Kuwait', type: 'Country' },
  'KZ': { label: 'Kazakhstan', type: 'Country' },
  'LA': { label: 'Laos', type: 'Country' },
  'LB': { label: 'Lebanon', type: 'Country' },
  'LC': { label: 'Saint Lucia', type: 'Country' },
  'LI': { label: 'Liechtenstein', type: 'Country' },
  'LK': { label: 'Sri Lanka', type: 'Country' },
  'LR': { label: 'Liberia', type: 'Country' },
  'LS': { label: 'Lesotho', type: 'Country' },
  'LT': { label: 'Lithuania', type: 'Country' },
  'LU': { label: 'Luxembourg', type: 'Country' },
  'LV': { label: 'Latvia', type: 'Country' },
  'LY': { label: 'Libya', type: 'Country' },
  'MA': { label: 'Morocco', type: 'Country' },
  'MC': { label: 'Monaco', type: 'Country' },
  'MD': { label: 'Moldova', type: 'Country' },
  'ME': { label: 'Montenegro', type: 'Country' },
  'MG': { label: 'Madagascar', type: 'Country' },
  'MH': { label: 'Marshall Islands', type: 'Country' },
  'MK': { label: 'North Macedonia', type: 'Country' },
  'ML': { label: 'Mali', type: 'Country' },
  'MM': { label: 'Myanmar', type: 'Country' },
  'MR': { label: 'Mauritania', type: 'Country' },
  'MT': { label: 'Malta', type: 'Country' },
  'MU': { label: 'Mauritius', type: 'Country' },
  'MW': { label: 'Malawi', type: 'Country' },
  'MX': { label: 'Mexico', type: 'Country' },
  'MY': { label: 'Malaysia', type: 'Country' },
  'MQ': { label: 'Martinique', type: 'Territory of France' },
  'MZ': { label: 'Mozambique', type: 'Country' },
  'NA': { label: 'Namibia', type: 'Country' },
  'NE': { label: 'Niger', type: 'Country' },
  'NF': { label: 'Norfolk Island', type: 'Territory of Australia' },
  'NG': { label: 'Nigeria', type: 'Country' },
  'NI': { label: 'Nicaragua', type: 'Country' },
  'NL': { label: 'Netherlands', type: 'Country' },
  'NO': { label: 'Norway', type: 'Country' },
  'NP': { label: 'Nepal', type: 'Country' },
  'NR': { label: 'Nauru', type: 'Country' },
  'NU': { label: 'Niue', type: 'Country' },
  'NZ': { label: 'New Zealand', type: 'Country' },
  'OM': { label: 'Oman', type: 'Country' },
  'PA': { label: 'Panama', type: 'Country' },
  'PE': { label: 'Peru', type: 'Country' },
  'PF': { label: 'French Polynesia', type: 'Territory of France' },
  'PG': { label: 'Papua New Guinea', type: 'Country' },
  'PH': { label: 'Philippines', type: 'Country' },
  'PK': { label: 'Pakistan', type: 'Country' },
  'PL': { label: 'Poland', type: 'Country' },
  'PM': { label: 'Saint Pierre and Miquelon', type: 'Territory of France' },
  'PN': { label: 'Pitcairn Islands', type: 'Territory of New Zealand' },
  'PR': { label: 'Puerto Rico', type: 'Territory of the United States' },
  'PT': { label: 'Portugal', type: 'Country' },
  'PW': { label: 'Palau', type: 'Country' },
  'PY': { label: 'Paraguay', type: 'Country' },
  'QA': { label: 'Qatar', type: 'Country' },
  'RE': { label: 'Réunion', type: 'Territory of France' },
  'RO': { label: 'Romania', type: 'Country' },
  'RS': { label: 'Serbia', type: 'Country' },
  'RU': { label: 'Russia', type: 'Country' },
  'RW': { label: 'Rwanda', type: 'Country' },
  'SA': { label: 'Saudi Arabia', type: 'Country' },
  'SB': { label: 'Solomon Islands', type: 'Country' },
  'SC': { label: 'Seychelles', type: 'Country' },
  'SD': { label: 'Sudan', type: 'Country' },
  'SE': { label: 'Sweden', type: 'Country' },
  'SG': { label: 'Singapore', type: 'Country' },
  'SH': { label: 'Saint Helena', type: 'Territory of the United Kingdom' },
  'SI': { label: 'Slovenia', type: 'Country' },
  'SJ': { label: 'Svalbard and Jan Mayen', type: 'Territory of Norway' },
  'SK': { label: 'Slovakia', type: 'Country' },
  'SL': { label: 'Sierra Leone', type: 'Country' },
  'SM': { label: 'San Marino', type: 'Country' },
  'SN': { label: 'Senegal', type: 'Country' },
  'SO': { label: 'Somalia', type: 'Country' },
  'SR': { label: 'Suriname', type: 'Country' },
  'SS': { label: 'South Sudan', type: 'Country' },
  'ST': { label: 'São Tomé and Príncipe', type: 'Country' },
  'SV': { label: 'El Salvador', type: 'Country' },
  'SX': { label: 'Sint Maarten', type: 'Country' },
  'SY': { label: 'Syria', type: 'Country' },
  'SZ': { label: 'Eswatini', type: 'Country' },
  'TC': { label: 'Turks and Caicos Islands', type: 'Territory of the United Kingdom' },
  'TD': { label: 'Chad', type: 'Country' },
  'TF': { label: 'French Southern and Antarctic Lands', type: 'Territory of France' },
  'TG': { label: 'Togo', type: 'Country' },
  'TH': { label: 'Thailand', type: 'Country' },
  'TJ': { label: 'Tajikistan', type: 'Country' },
  'TK': { label: 'Tokelau', type: 'Territory of New Zealand' },
  'TL': { label: 'Timor-Leste', type: 'Country' },
  'TM': { label: 'Turkmenistan', type: 'Country' },
  'TN': { label: 'Tunisia', type: 'Country' },
  'TO': { label: 'Tonga', type: 'Country' },
  'TR': { label: 'Turkey', type: 'Country' },
  'TT': { label: 'Trinidad and Tobago', type: 'Country' },
  'TV': { label: 'Tuvalu', type: 'Country' },
  'TZ': { label: 'Tanzania', type: 'Country' },
  'UA': { label: 'Ukraine', type: 'Country' },
  'UG': { label: 'Uganda', type: 'Country' },
  'US': { label: 'United States', type: 'Country',
    children: [
      { label: 'PADD I', value: 'PADD I', type: 'Region' },
      { label: 'PADD II', value: 'PADD II', type: 'Region' },
      { label: 'PADD III', value: 'PADD III', type: 'Region' },
      { label: 'PADD IV', value: 'PADD IV', type: 'Region' },
      { label: 'PADD V', value: 'PADD V', type: 'Region' }
    ]},
  'UY': { label: 'Uruguay', type: 'Country' },
  'UZ': { label: 'Uzbekistan', type: 'Country' },
  'VA': { label: 'Vatican City', type: 'Country' },
  'VC': { label: 'Saint Vincent and the Grenadines', type: 'Country' },
  'VE': { label: 'Venezuela', type: 'Country' },
  'VI': { label: 'U.S. Virgin Islands', type: 'Territory of the United States' },
  'VN': { label: 'Vietnam', type: 'Country' },
  'VU': { label: 'Vanuatu', type: 'Country' },
  'WF': { label: 'Wallis and Futuna', type: 'Territory of France' },
  'TW': { label: 'Taiwan', type: 'Country' },
  'WS': { label: 'Samoa', type: 'Country' },
  'YE': { label: 'Yemen', type: 'Country' },
  'YT': { label: 'Mayotte', type: 'Territory of France' },
  'ZA': { label: 'South Africa', type: 'Country' },
  'ZM': { label: 'Zambia', type: 'Country' },
  'ZW': { label: 'Zimbabwe', type: 'Country' },
  'OP': { label: 'OPEC Total', type: 'Aggregate' },
  'OO': { label: 'OPEC+ Total', type: 'Aggregate' },
  'OD': { label: 'OECD Total', type: 'Aggregate' },
  'OE': { label: 'Other Europe', type: 'Aggregate' },
  'OT': { label: 'Other Latam', type: 'Aggregate' },
  'OC': { label: 'Other CIS', type: 'Aggregate' },
  'OA': { label: 'Other Africa', type: 'Aggregate' },
  'CT': { label: 'Total of all countries', type: 'Aggregate' },
  'ZT': { label: 'Europe Total', type: 'Aggregate'},
  'ZP': { label: 'Asia Total', type: 'Aggregate'},
  'ZO': { label: 'OPEC+ (Outside of OPEC)', type: 'Aggregate'},
  'ZN': { label: 'North America Total (Exc. Mexico)', type: 'Aggregate' },
  'ZL': { label: 'Latin America Total (Inc. Mexico)', type: 'Aggregate' },
  'ZF': { label: 'Africa Total', type: 'Aggregate' },
  'ZE': { label: 'Middle East Total', type: 'Aggregate' },
  'ZC': { label: 'CIS Total', type: 'Aggregate' },
  'WN': { label: 'North Africa', type: 'Aggregate' },
  'WA': { label: 'West Africa', type: 'Aggregate' },
  'OU': { label: 'OECD Europe', type: 'Aggregate'},
  'OS': { label: 'Other Asia', type: 'Aggregate' },
  'ON': { label: 'OECD North America', type: 'Aggregate'},
  'OA': { label: 'OECD Europe', type: 'Aggregate'},
  'NN': { label: 'North Asia', type: 'Aggregate' },
  'LM': { label: 'OECD Latin America', type: 'Aggregate'},
  'IA': { label: 'South Asia', type: 'Aggregate' },
  'EU': { label: 'EU', type: 'Aggregate' },
  'EN': { label: 'Northwest Europe', type: 'Aggregate' },
  'EM': { label: 'Mediterranean Europe', type: 'Aggregate' },
  'AP': { label: 'Southeast Asia-Pacific', type: 'Aggregate' },
  'AA': { label: 'OECD Asia', type: 'Aggregate'},
  'OF': { label: 'Other Middle East', type: 'Aggregate' },
    'PP': { label: 'Non-OPEC Total', type: 'Aggregate' },
  'DD': { label: 'Non-OECD Total', type: 'Aggregate' },
  'ZZ': { label: 'Neutral Zone', type: 'Aggregate' }
};

export default countriesDictionary;